import getFromCdn from '@anm/helpers/getFromCdn';
import { FC } from 'react';
import styled from 'styled-components';

export type NoCardProps = {};

const Wrapper = styled.div`
  border: 1px solid #cbdce5;
  width: 100%;
  padding: 20px 30px;
  border-radius: 5px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #ebeef5;
`;

const NoCardBlock = styled.div`
  display: flex;
  align-items: center;
`;

const Rectangle = styled.div`
  background-color: #ced1d8;
  width: 32px;
  height: 25px;
  border-radius: 3px;
`;

const Text = styled.div`
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  color: #919eaa;
  margin-top: 10px;
`;

const CardDots = styled.div`
  background-image: url(${getFromCdn(`images/icons/card-dots4.svg`)});
  background-repeat: no-repeat;
  display: inline-block;
  width: 100%;
  height: 4px;
  margin-left: 47px;
`;

const NoCard: FC<NoCardProps> = () => (
  <Wrapper>
    <NoCardBlock>
      <Rectangle />
      <CardDots />
    </NoCardBlock>

    <Text>You have no card info</Text>
  </Wrapper>
);

export default NoCard;
